<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: arrow</title>
  <path
    d="M22,8.8817842e-16 C23.1045695,8.8817842e-16 24,0.8954305 24,2 L24,11 L21.8,11 L21.8,3.761 L1.56165954,24 L0,22.4383405 L20.238,2.2 L13,2.2 L13,4.4408921e-16 L22,8.8817842e-16 Z"
  />
</Icon>
